const GoogleMap = () => {
 return (
  <iframe
   className='Gmap px-2'
   height={250}
   loading='lazy'
   allowFullScreen={true}
   src='https://www.google.com/maps/embed/v1/place?q=place_id:ChIJ6X225ku6HRURnpX60dHvQbQ&key=AIzaSyCNYRiNeUGODLoFznmHcdv9fGloz06EuLI'
   title='Google Map'></iframe>
 );
};

export default GoogleMap;
